module.exports = __webpack_public_path__ + "static/shotlists_setups@3x-ea2ff1097eca6fc5bc4bb77aa2dd07df.png";